module.exports = "/packs/images/social_enerprise_logo_black--desktop~f9b07e73136523812b3464dc538efa56.gif";